export default __webpack_public_path__ + "static/media/team.c47bd77f.png";